<template>
  <div>
    <form
      @submit.prevent="activate()"
      v-show="bundle_done == false && bundle_response == ''"
    >
      <div class="bundle-activation-card-options">
        <label class="mr-1"
          ><input
            :name="bdl.id"
            value="activate"
            type="radio"
            checked="checked"
            v-model="bundle_args.bundle_option"
          />
          <div>Activer</div>
          <p class="text-muted">Activer sur votre numéro</p></label
        >
        <label
          ><input
            :name="bdl.id"
            v-model="bundle_args.bundle_option"
            value="offer"
            type="radio"
          />
          <div>Offrir</div>
          <p class="text-muted">Activer sur un autre numéro</p></label
        >
      </div>
      <div class="bundle-activation-card-payment-mode mt-2">
        <div class="form-group">
          <div>
            <label class="font-weight-bold"
              >Sélectionnez un mode de paiement</label
            >
          </div>
          <label class="mr-3"
            ><input
              value="main"
              :name="'mode_' + bdl.id"
              type="radio"
              checked="checked"
              class="hidden-radio"
              v-model="bundle_args.paysrc"
            />
            <span class="bundle-mode-icon mr-2"
              ><i class="mtn-icon mtn-icon-phone"></i
            ></span>
            <span class="bundle-mode-title">Compte principal</span></label
          >
          <label
            ><input
              value="MO"
              :name="'mode_' + bdl.id"
              type="radio"
              class="hidden-radio"
              v-model="bundle_args.paysrc"
            />
            <span class="bundle-mode-icon mr-2"
              ><i class="mtn-icon mtn-icon-mtn-momo"></i
            ></span>
            <span class="bundle-mode-title">Mobile Money</span></label
          >
        </div>
      </div>
      <div>
        <div v-if="bundle_args.bundle_option == 'offer'" class="form-group">
          <label class="font-weight-bold">Numéro du bénéficiaire</label>
          <input
            required="required"
            autocomplete="off"
            placeholder="Ex 0162192020"
            type="number"
            class="form-control"
            v-model="bundle_args.benmsisdn"
          />
        </div>
      </div>
      <div>
        <button class="btn btn-primary float-right" :disabled="is_loading_bdl">
          <b-spinner
            small
            v-if="is_loading_bdl"
            label="En cours..."
          ></b-spinner>
          <span v-if="is_loading_bdl == false">Activer</span>
        </button>
      </div>
      <div class="clearfix"></div>
    </form>
    <div
      class="text-center"
      id="bundle_success_message"
      v-if="bundle_done == true && bundle_response !== ''"
    >
      <div class="text-center">
        <i
          class="mdi mdi-check success"
          v-if="bundle_response.success == true"
        ></i>
        <i
          class="mdi mdi-alert-circle-check error"
          v-else-if="bundle_response.success == false"
        ></i>
        <p class="font-14 font-bold pt-3 px-0 px-md-5">
          {{ bundle_response.response }}
        </p>
        <div class="text-center mt-2">
          <a class="font-14" @click.prevent="re_init()" href="#">
            <b>Reprendre</b>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { subscriber } from "@/services/";
export default {
  props: ["bdl"],
  components: {},
  name: "BundleDetails",
  data: function () {
    return {
      bundle_args: {
        code: this.bdl.id,
        bundle_option: "activate",
        benmsisdn: "",
        paysrc: "main",
      },
      is_loading_bdl: false,
      bundle_done: false,
      bundle_response: "",
    };
  },
  mounted: async function () {},
  methods: {
    re_init: function () {
      this.is_loading_bdl = false;
      (this.bundle_done = false), (this.bundle_response = "");
    },
    activate: async function () {
      if (this.is_loading_bdl == true) {
        return;
      } else {
        if (confirm("Voulez vous vraiment continuer ?")) {
          this.is_loading_bdl = true;
          if (this.bundle_args.bundle_option === 'offer') {
            this.bundle_args.code = this.bdl.kdo
          }
          try {
            await subscriber
              .activate_bundle(this.bundle_args)
              .then((response) => {
                this.is_loading_bdl = false;
                (this.bundle_done = true), (this.bundle_response = response);
              });
          } catch (error) {
            this.is_loading_bdl = false;
          }
        } else {
          this.is_loading_bdl = false;
          return;
        }
      }
    },
  },
};
</script>
<style scoped lang="css">
#bundle_success_message {
  padding: 30px 15px;
}
#bundle_success_message {
  padding: 30px 15px;
}
#bundle_success_message i {
  width: 60px;
  height: 60px;
  display: block;
  margin: 0 auto;
  border-radius: 50%;
  color: #fff;
  text-align: center;
  font-size: 42px;
}
#bundle_success_message .success {
  background: #5cb85c;
}
#bundle_success_message .error {
  color: #dda129;
  font-size: 62px;
}
</style>
